import React, { useState, useRef, useEffect } from "react";
import { Card } from "reactstrap";
import { Plus, PlusCircle, Search, SearchIcon } from "lucide-react";
import CommonTable from "../../CommonTable";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from "react-i18next";
import AddTestProfile from "./AddTestProfile";
import Swal from "sweetalert2";

export default function HomeTestProfileList() {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [edit, setEdit] = useState(false)
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [data, setData] = useState({})
    const [users, setUsers] = useState([
        { name: "Hammad Raza", status: "Active" },
        { name: "Mubarak", status: "Inactive" },
    ]);

    const columns = [
        { header: "Test Profile Name", accessor: "name" },
    ];

    const handleToggleStatus = (user) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to chane status!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Update"
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    // title: "Deleted!",
                    text: "Your file has been updated.",
                    icon: "success"
                });
            }
        });

        setUsers((prev) =>
            prev.map((u) =>
                u.name === user.name
                    ? { ...u, status: u.status === "Active" ? "Inactive" : "Active" }
                    : u
            )
        );
    };

    const actions = [
        { label: "Edit", onClick: (row) => handleEdit(row) },
        { label: "Delete", onClick: (row) => console.log(row) },
    ]

    const handleEdit = (row) => {
        // console.log(row)
        setData(row)
        setEdit(true)
    }

    const editClose = () => {
        setEdit(false)
    }
    return (
        <>
            <Card>
                <div className="px-3 mt-4">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="input-group mb-3 ">
                                <span className="input-group-text tw-bg-white" id="basic-addon1"><SearchIcon /></span>
                                <input type="text" className="form-control icon_form" placeholder="Search By Test Profile..." aria-label="Username" aria-describedby="basic-addon1" style={{ borderLeft: 'none' }} />
                            </div>

                        </div>
                        <div className="col-md-6 text-end">
                            <button className="btn btn-primary" onClick={handleShow}>
                                {t("Add")}
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <CommonTable
                                columns={columns}
                                data={users}
                                onToggleStatus={handleToggleStatus}
                                onAction={actions}
                            />
                        </div>
                    </div>
                </div>
            </Card>

            <Modal show={show} onHide={handleClose}>
                <AddTestProfile handleClose={handleClose} />
            </Modal>

            <Modal show={edit} onHide={editClose}>
                <AddTestProfile handleClose={editClose} data={data} />
            </Modal>
        </>
    )
}
